import { ofetch } from "ofetch";
import type { FetchOptions } from "ofetch";

const _client = ofetch.create({
  credentials: "include",
  onResponseError: async ({ response }) => {
    if (response?.status === 401 && window.location.pathname !== "/login") {
      window.location.href = `/login?next=${encodeURIComponent(window.location.pathname)}`;
    }
  },
});

type JsonOpts = FetchOptions<"json">;
type Body = JsonOpts["body"];

const merge = (method: string, body?: Body, opts?: JsonOpts): JsonOpts =>
  ({ ...opts, method, body, responseType: "json" }) as JsonOpts;

export const apiClient = {
  get: <T = unknown>(url: string, opts?: JsonOpts) =>
    _client<T, "json">(url, merge("GET", undefined, opts)),
  post: <T = unknown>(url: string, body?: Body, opts?: JsonOpts) =>
    _client<T, "json">(url, merge("POST", body, opts)),
  put: <T = unknown>(url: string, body?: Body, opts?: JsonOpts) =>
    _client<T, "json">(url, merge("PUT", body, opts)),
  patch: <T = unknown>(url: string, body?: Body, opts?: JsonOpts) =>
    _client<T, "json">(url, merge("PATCH", body, opts)),
  delete: <T = unknown>(url: string, opts?: JsonOpts) =>
    _client<T, "json">(url, merge("DELETE", undefined, opts)),
};
